import type { CshGroup } from "../../services/csh/csh.types";
import { getAssignedUserId, getAssignedUserLabel } from "./cshGroupAssignments";

interface Props {
    group: CshGroup;
    canManage: boolean;
    downloadingSites: boolean;
    downloadingUsers: boolean;
    onDownload: (id: string, kind: "sites" | "users") => void;
    onEdit: (group: CshGroup) => void;
    onDelete: (group: CshGroup) => void;
}

export function CshGroupDetailsPanel({ group, canManage, downloadingSites, downloadingUsers, onDownload, onEdit, onDelete }: Props) {
    const customers = group.customers.filter(customer => customer.customerName && customer.customerName !== "N/A");
    return (
        <div>
            <div className="admin-requests--panel-heading">
                <h4 className="heading heading__title--csh mt-0">{group.name}</h4>
            </div>
            <div className="mt-0">
                <h4 className="mb-0 mt-0">Customers &amp; Sites:</h4>
                <div className="panel-box">
                    {customers.length ? customers.map(customer => (
                        <div key={customer.customerId} className="mt-1">
                            <strong style={{ fontSize: "0.9rem" }}>{customer.customerName}</strong>
                            <div className="tags tags--sites">
                                {customer.sites.length ? customer.sites.map(site => (
                                    <a key={site.siteId} href={`/sites/${encodeURIComponent(String(site.siteId))}`}
                                        className="site-tag" onClick={event => event.stopPropagation()}>
                                        <span>{site.siteName ?? `Site ${site.siteId}`}</span>
                                    </a>
                                )) : <div>No sites</div>}
                            </div>
                        </div>
                    )) : <div>No customers</div>}
                </div>
                <button className="btn btn-download mt-1" disabled={downloadingSites} onClick={() => onDownload(group.id, "sites")}>
                    {downloadingSites ? "Downloading…" : "Download Sites"}
                </button>
            </div>
            <div className="mt-1">
                <h4>Assigned To:</h4>
                <div className="tags tags--users">
                    {group.assignedTo.length ? group.assignedTo.map(user => (
                        <span key={getAssignedUserId(user) || getAssignedUserLabel(user)} className="rule-tag">
                            <span>{getAssignedUserLabel(user)}</span>
                        </span>
                    )) : <div>No users assigned</div>}
                </div>
                <button className="btn btn-download mt-1" disabled={downloadingUsers} onClick={() => onDownload(group.id, "users")}>
                    {downloadingUsers ? "Downloading…" : "Download Users"}
                </button>
            </div>
            {canManage && (
                <div className="admin-requests__buttons">
                    <button className="btn btn-edit" onClick={() => onEdit(group)}>Edit</button>
                    <button className="btn btn__error" onClick={() => onDelete(group)}>Delete</button>
                </div>
            )}
        </div>
    );
}
